import { CREATE_MATERIAL, LIST_OF_MATERIAL, MATERIAL } from "./ApiRoutes";
import { authData } from "./services";

export const listOfMaterial = async (data: object) => {
  const response = await authData.post(LIST_OF_MATERIAL, data);
  return response?.data;
};

export const createMaterial = async (data: object) => {
  const response = await authData.post(CREATE_MATERIAL, data);
  return response?.data;
};

export const deleteMaterial = async (id: number) => {
  const response = await authData.delete(`${MATERIAL}${id}`);
  return response?.data;
};

export const editMaterial = async (id: number, data: object) => {
  const response = await authData.put(`${MATERIAL}${id}`, data);
  return response?.data;
};

export const viewMaterial = async (id: number) => {
  const response = await authData.get(`${MATERIAL}${id}`);
  return response?.data;
};
